import React, { useState } from 'react'

import './styles.scss'
import { Form } from "@unform/web";
import Input from '../../components/Input/input';
import { RiCloseCircleLine } from 'react-icons/ri'
import DateTimePicker from 'react-datetime-picker';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { createDrugstore, updateDrugstore } from '../../services/farmacias';
import getRequestBody from '../../helpers/requestBody';

export default function FormComponent(props) {

  const { selectedStore } = props;
  const MySwal = withReactContent(Swal)

  const [ sameNumber, setSameNumber ] = useState(false);
  const [ startDate, setStartDate ] = useState('');
  const [ endDate, setEndDate ] = useState('');

  function handleSubmit(data, { reset }) {

     data.Whatsapp = data.Whatsapp || data.Telefone;  

    if (startDate === ''||endDate === '')  { 
      MySwal.fire(
        'Esqueceu a data ?',
        'Por favor, preencha a data de início e fim',
        'error'
      )
    } else {

      try {
        const requestBody = getRequestBody(data, startDate, endDate);
        !selectedStore ? createDrugstore(requestBody) : updateDrugstore(selectedStore._id, requestBody)
        props.close()
        props.reset()

        MySwal.fire(
          'Boa',
          'Cadastro salvo com sucesso',
          'success'
        )
      } catch(err) {
        console.log(err)
      }
    } 
  }

  const handleChange = () => {
    setSameNumber(!sameNumber)
  }

  return (
    <div className='formMain'>
      <div className='formHeader'>
        <h1>{props.title}</h1>
        <RiCloseCircleLine onClick={() => props.close()} color='white' size={20} />
      </div>
        <div className='infos'>
        <div className='horario'>
            <small className='info_title_hor'>Horários</small>
            <DateTimePicker onChange={setStartDate} value={startDate} />
            <DateTimePicker onChange={setEndDate} value={endDate} />
          </div>
        <Form className='formField' onSubmit={handleSubmit}>
          <Input defaultValue={selectedStore?.name || ''} name="Nome" label="Nome" />
          <Input defaultValue={selectedStore?.endereco.logradouro || ''} name="Logradouro" label="Logradouro"/>
          <Input defaultValue={selectedStore?.endereco.numero || ''} name="Numero" label="Numero" />
          <Input defaultValue={selectedStore?.endereco.bairro || ''} name="Bairro" label="Bairro"/>
        
          <Input defaultValue={selectedStore?.contatos.tel || ''} name="Telefone" label="Telefone" />
          <div className='whatsapp'>
            <input onChange={() => handleChange()} type='checkbox' />
            <span>Mesmo numero de Whatsapp</span>
          </div>
          { !sameNumber ? (
              <Input defaultValue={selectedStore?.contatos.whatsapp || ''} name="Whatsapp" label="Whatsapp" />
          ) : null }
          <button type="submit">{props.title}</button>
        </Form>
       
        </div>
    </div>
  )
}
